import { AuthenticatedUserModel } from "@courses-utils/gateway-auth";

import { GridColumn, GridModel } from "@courses-pm2/api/src/ts/models";
import { Engine } from "@courses-pm2/api/src/ts/utils";

import { getChildrenByTagName } from "@courses-pm2/api/src/ts/parser/getChildrenByTagName";
import { parseChildElements } from "@courses-pm2/api/src/ts/parser/parseChildElements";

/**
 * Helper that parses <Row /> elements in the response from the pm2 backend.
 */
export async function parseGrid({ node, portalId, user, engine }: {
    node: Element;
    portalId: string;
    user?: AuthenticatedUserModel;
    engine?: Engine;
}): Promise<GridModel> {
    // Announce that a model has been identified if possible
    if (engine) {
        engine.announce(GridModel);
    }

    // Iterate over the columns, and begin parsing the elements within them
    const columns: GridColumn[] = [];

    for (const column of getChildrenByTagName(node, "Column")) {
        columns.push({
            content: await parseChildElements({
                node: column,
                portalId,
                user,
                engine,
            }),
            size: parseInt(column.getAttribute("size") || "1", 10),
        });
    }

    return new GridModel({
        isScrambled: parseInt(node.getAttribute("access") ?? "0", 10) > 0,
        engine,
        portalId,
        columns,
    });
}
